import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Single-file translation loader for optimal performance
 * Loads a single combined translation file per language
 *
 * Structure:
 *   src/assets/i18n/en.json (combined English)
 *   src/assets/i18n/pl.json (combined Polish)
 */
export class MultiTranslateHttpLoader implements TranslateLoader {
  private prefix: string;
  private suffix: string;

  constructor(
    private http: HttpClient,
    prefix: string,
    suffix: string
  ) {
    this.prefix = prefix;
    this.suffix = suffix;
  }

  getTranslation(lang: string): Observable<any> {
    // Load single combined translation file for better performance
    // This reduces 11 HTTP requests down to 1
    return this.http.get<any>(`${this.prefix}${lang}${this.suffix}`).pipe(
      catchError((error) => {
        // Fallback to English if requested language fails
        if (lang !== 'en') {
          return this.http.get<any>(`${this.prefix}en${this.suffix}`);
        }
        return of({});
      })
    );
  }
}

/**
 * Factory function to create MultiTranslateHttpLoader instance
 * This is required because Angular DI cannot inject primitive values directly
 */
export function MultiTranslateHttpLoaderFactory(http: HttpClient): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(
    http,
    '/assets/i18n/',
    '.json'
  );
}
